<template>
  <div
    v-show="open"
    class="
      insights-floating-sidepane
      tw-flex
      tw-flex-col
      tw-bg-white
      tw-border
      tw-border-solid
      tw-border-sf-slate-lighter-1
      tw-rounded-lg
      tw-overflow-hidden
      tw-h-full
      tw-w-[406px]
      tw-shrink-0
    "
    data-testid="insights-floating-sidepane"
  >
    <div
      class="
        tw-flex
        tw-items-center
        tw-justify-between
        tw-gap-2
        tw-px-4
        tw-py-3
        tw-border-0
        tw-border-b
        tw-border-solid
        tw-border-sf-slate-lighter-1
        tw-shrink-0
      "
    >
      <h2
        class="
          tw-m-0
          tw-p-0
          tw-text-lg
          tw-font-medium
          tw-text-sf-slate-darker-1
          tw-leading-tight
        "
      >
        {{ I18n.t('companies_overview.setup_your_query') }}
      </h2>
      <SfButtonDs
        variant="tertiary"
        icon-only
        icon-before="xmark"
        :aria-label="I18n.t('companies_overview.collapse_sidepane')"
        data-testid="insights-floating-sidepane-close"
        @click="onClose"
      />
    </div>

    <div class="tw-flex-1 tw-overflow-auto">
      <InsightsLeftPanelLite v-if="isLite" />
      <InsightsLeftPanelFull v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import InsightsLeftPanelFull from './insights-left-panel-full.vue'
import InsightsLeftPanelLite from './insights-left-panel-lite.vue'
import { useInsightsSidepaneVisibility } from '../composables/use-insights-sidepane-visibility'
import { provideInsightsLayoutContext } from '../composables/use-insights-layout-context'

defineOptions({ name: 'InsightsFloatingSidepane' })

defineProps<{
  isLite: boolean
}>()

const I18n = useI18n()
const { open, setOpen } = useInsightsSidepaneVisibility()

provideInsightsLayoutContext({ inFloatingSidepane: true })

function onClose(): void {
  setOpen(false)
}
</script>
